export default __webpack_public_path__ + "static/media/chatton3.96c224bf.jpg";